import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FORMAT_TEXT_COMMAND, FORMAT_ELEMENT_COMMAND, UNDO_COMMAND, REDO_COMMAND } from 'lexical';
import { INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND } from '@lexical/list';

export default function ToolbarPlugin() {
  const [editor] = useLexicalComposerContext();

  const buttonClass =
    'w-8 h-8 flex items-center justify-center rounded text-sm text-foreground-600 hover:bg-background-200 hover:text-foreground-900 transition-colors cursor-pointer';
  const activeClass = 'bg-accent-100 text-accent-700';

  return (
    <div className="flex items-center gap-1 px-3 py-2 border-b border-background-200 bg-background-50 flex-wrap">
      <button
        onClick={() => editor.dispatchCommand(UNDO_COMMAND, undefined)}
        className={buttonClass}
        title="Undo"
        type="button"
        aria-label="Undo"
      >
        <i className="ri-arrow-go-back-line" />
      </button>
      <button
        onClick={() => editor.dispatchCommand(REDO_COMMAND, undefined)}
        className={buttonClass}
        title="Redo"
        type="button"
        aria-label="Redo"
      >
        <i className="ri-arrow-go-forward-line" />
      </button>

      <span className="w-px h-5 bg-background-200 mx-1" />

      <button
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')}
        className={buttonClass}
        title="Bold"
        type="button"
        aria-label="Bold"
      >
        <i className="ri-bold" />
      </button>
      <button
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')}
        className={buttonClass}
        title="Italic"
        type="button"
        aria-label="Italic"
      >
        <i className="ri-italic" />
      </button>
      <button
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')}
        className={buttonClass}
        title="Underline"
        type="button"
        aria-label="Underline"
      >
        <i className="ri-underline" />
      </button>
      <button
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough')}
        className={buttonClass}
        title="Strikethrough"
        type="button"
        aria-label="Strikethrough"
      >
        <i className="ri-strikethrough" />
      </button>

      <span className="w-px h-5 bg-background-200 mx-1" />

      <button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'h2')}
        className={buttonClass}
        title="Heading 2"
        type="button"
        aria-label="Heading 2"
      >
        <span className="text-xs font-bold">H2</span>
      </button>
      <button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'h3')}
        className={buttonClass}
        title="Heading 3"
        type="button"
        aria-label="Heading 3"
      >
        <span className="text-xs font-bold">H3</span>
      </button>
      <button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'h4')}
        className={buttonClass}
        title="Heading 4"
        type="button"
        aria-label="Heading 4"
      >
        <span className="text-xs font-bold">H4</span>
      </button>

      <span className="w-px h-5 bg-background-200 mx-1" />

      <button
        onClick={() => editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined)}
        className={buttonClass}
        title="Bullet List"
        type="button"
        aria-label="Bullet List"
      >
        <i className="ri-list-unordered" />
      </button>
      <button
        onClick={() => editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined)}
        className={buttonClass}
        title="Numbered List"
        type="button"
        aria-label="Numbered List"
      >
        <i className="ri-list-ordered" />
      </button>
      <button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'quote')}
        className={buttonClass}
        title="Quote"
        type="button"
        aria-label="Quote"
      >
        <i className="ri-double-quotes-l" />
      </button>

      <span className="w-px h-5 bg-background-200 mx-1" />

      <button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left')}
        className={buttonClass}
        title="Align Left"
        type="button"
        aria-label="Align Left"
      >
        <i className="ri-align-left" />
      </button>
      <button
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center')}
        className={buttonClass}
        title="Align Center"
        type="button"
        aria-label="Align Center"
      >
        <i className="ri-align-center" />
      </button>
    </div>
  );
}